import constant from "../../../../constants/constant";
import { IsViewDataProps } from "../interface";

export const useFindGstType = () => {
    const showGstField = (props: IsViewDataProps | undefined): boolean => {
        if (props?.created_by === constant.INVENTORY_CREATED_BY.SUPER_ADMIN) {
            return props.supplier?.gst_type === constant.GST_TYPE[0].value;
        } else {
            return (
                props?.physical_store?.gst_type === constant?.GST_DETAILS.REGULAR ?
                props?.category === constant.INVOICE_CATEGORY[5]?.value && props?.gst_invoice : props?.category === constant.INVOICE_CATEGORY[5]?.value && props?.non_gst_invoice
            );
        }
    };
    return {
        showGstField,
    };
};
